import { DocsLinksSection } from 'components/docs/docs-links-section';

const DocsConceptsSection = ({ section }) => <DocsLinksSection icon='cubes' section={section} />;

export { DocsConceptsSection };
